<template>
  <div class="reservation-summary flex items-center">
    <div v-if="!isSoldOut" class="reservation-info">
      <div class="attendance text-sm">
        <span>{{ t('branch_detail.selection.people', { pax: attendance }, attendance) }}</span>
      </div>
      <div class="date-and-discount">
        <span>{{ dateString }}</span>
        <span>, </span>
        <span>{{ timeString }}</span>
        <span> / </span>
        <span>-{{ slotInfo?.discount || '-' }}%</span>
      </div>
    </div>
    <etg-button type="primary" class="ml-auto" :loading="isReservationNextStepLoading" :disabled="!canNextStep" @click="handleNextStepClick">
      {{ nextStepBtnText }}
    </etg-button>
  </div>
</template>

<script setup lang="ts">
const { t } = useI18n()

const { branch, attendance, date, slotInfo, isSoldOut } = useBranchDetailContext()
const { format } = useI18nDateFns()
const { formatDateWithI18n } = useI18nDateString()
const { isReservationNextStepLoading, processReservationNextStep } = useReservationNextStep({ branch, attendance, date, slotInfo, format })

const nextStepBtnText = computed(() => (isSoldOut?.value ? t('branch_detail.bottom_bar.sold_out') : t('branch_detail.bottom_bar.next')))
const canNextStep = computed(() => !isSoldOut?.value && attendance.value > 0 && date.value && slotInfo.value?.slot)

const dateString = computed(() => (date.value ? formatDateWithI18n(date.value, 'MMMD') : ''))
const timeString = computed(() => (slotInfo.value?.slot ? format(new Date(slotInfo.value.slot), 'HH:mm') : `--:--`))

const handleNextStepClick = () => {
  if (!canNextStep.value) return

  processReservationNextStep()
}
</script>
